jQuery(function($){

	$('.button-update-cart').click(function(){

		var total = parseInt(0);

		$('.woocommerce-cart').find('input.qty').each(function(){
			var value = $(this).val();
			total = total + parseInt(value);
		});

		$('.navbar-shopping-cart > .cart-contents > span').html(total);
	});

	$('.product-remove > a.remove').click(function(){

		console.log('REMOVE');

		var removeValue = $(this).closest('.cart_item').find('input.qty').val();
		console.log('removeValue = ' + removeValue);

		var cart_total = $('.navbar-shopping-cart > .cart-contents > span').html();
		console.log('cart_total = ' + cart_total);

		var total = (parseInt(cart_total) - parseInt(removeValue));
		console.log('total = ' + total);

		$('.navbar-shopping-cart > .cart-contents > span').html(total);
	});
});